var $ = jQuery;

function download() {
    'use strict';
    var form = $( '#downloads-list' ).ajaxForm(),
        formElements = $( '#downloads-list input:checkbox' ),
        elementNames = $( '#downloads-list > ul > li > div > p > label > span#file-title' ),
        elementsInfo = $( '#downloads-list > ul > li > div > p > span#file-info' ),
        submit = $( 'span#download' ),
        files = {},
        fileLinks = {},
        links = [];

    for ( var i = 0; i < formElements.length; i++ ) {
        var formElement = formElements[ i ];
        var elementName = elementNames[ i ];
        var elementInfo = elementsInfo[ i ];
        var link = $( formElement ).val();
        var file = $.trim( $( elementName ).text() );
        var info = $.trim( $( elementInfo ).text() );

        if ( $( formElement ).is( ':checked' ) ) {
            links.push( link );
            files[ file ] = info;
            fileLinks[ file ] = link;
        }
    }

    if ( links.length !== 0 ) {

        var filelist = $( '#download-form > form > div > div > ul#filelist' );

        filelist.children().remove();

        $.each( files, function ( file, info ) {
            var fileinfo = "<li id='file'><span style='font-weight:bold'>" + file + "</span><br><span style='color:#666'>" + info + "</span></li>";
            $( filelist ).append( fileinfo );
        } );

        $( 'div#download-form' ).bPopup( {
            closeClass: 'button-close',
            modalClose: false,
            transition: 'slideDown',
            positionStyle: 'fixed',
            amsl: 150,
            modalColor: '#FFFFFF',
            opacity: '0.9',
            onClose: function () {
                filelist.children().remove();
                $( '#sent' ).hide().removeClass( 'success' ).removeClass( 'error' ).html('');
            }
        } );
    }

    return fileLinks;
}

function updateCounter() {
    var count = $( '#downloads-list input:checkbox:checked' ).length,
        counter = $( 'span#download > span#counter' );

    if ( count > 0 ) {
        counter.text( '(' + count + ')' );
    } else {
        counter.text( '' );
    }

    return count;
}

function counterCheck() {
    var count = updateCounter();
    if ( count === 0 ) {
        $( 'span#download' ).addClass( 'disabled' );
    } else {
        $( 'span#download' ).removeClass( 'disabled' );
    }
}

$( document ).ready( function () {
    $( '#downloads-list' ).on( 'change', function ( event ) {
        event.preventDefault();
        updateCounter();
        counterCheck();
    } );

    $('form#downloads-send').validate({
        highlight: function(element, errorClass, validClass) {
            $(element.form).find("label[for=" + element.id + "] > span.star").addClass(errorClass);
        },
        unhighlight: function(element, errorClass, validClass) {
            $(element.form).find("label[for=" + element.id + "] > span.star").hide();
        },
        rules: {
            company: {
                required: true
            },
            person: {
                required: true
            },
            email: {
                required: true,
                email: true
            }
        },
        messages: {
            company: {
                required: 'obligatoriskt'
            },
            person: {
                required: 'obligatoriskt'
            },
            email: {
                required: 'obligatoriskt',
                email: 'ange en e-postadress'
            }
        },
        submitHandler: function() {
            var filesData = download(),
                formData = {};

            $.each($('form#downloads-send').serializeArray(), function() {
                formData[this.name] = this.value;
            })

            var nounce = $( '#downloads-nounce' ).val();

            $.ajax({
                url: downloadAjax.ajaxUrl,
                type: 'POST',
                dataTypw: 'json',
                data: {
                    action: 'senddownloads',
                    filesData: filesData,
                    formData: formData,
                    nounce: nounce
                },
                success: function( response ) {
                    response = JSON.parse( response );
                    console.log( response );
                    if ( 'error' === response.status ) {
                        $('#sent').show().removeClass( 'success' ).addClass( 'error' ).html('Error');
                    } else {
                        $('#sent').show().removeClass( 'error' ).addClass( 'success' ).html('Filerna har skickats!');
                        updateCounter();
                        counterCheck();
                        $('form#downloads-send').resetForm();
                        $('#download-form > form > div > div > ul#filelist').children().remove();
                        document.getElementById('downloads-list').reset();
                        ga('send', 'event', 'form', 'submit', 'download');
                    }
                },
                error: function() {
                    $('#sent').show().removeClass( 'success' ).addClass( 'error' ).html('Error');
                    updateCounter();
                }
            });

            updateCounter();
        }
    });
} );

